import React from "react";
import { twMerge } from "tailwind-merge";
import Spinner from "shared/components/common/Spinner";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";

const PillarTableSpinner = () => {
  const {
    testidTable,
    columns,
    loadedFirstTime,
    isFetchingPreviousPage,
    isFetchingNextPage,
    dataQueryError,
  } = usePillarTableContext();
  const showInfinityLoading = isFetchingPreviousPage || isFetchingNextPage;

  // Once a load has failed there is nothing left to wait for, so the spinner
  // gives way to PillarTableError until a retry starts a fresh fetch.
  if (dataQueryError) {
    return <></>;
  }

  if (!loadedFirstTime || showInfinityLoading) {
    return (
      <tr
        className={twMerge(
          "pillartable-table-row-general bg-neutral-light",
          showInfinityLoading &&
            twMerge(
              "absolute",
              isFetchingPreviousPage && "top-0",
              isFetchingNextPage && "bottom-0",
              "inset-x-0",
              "z-10",
              "flex justify-center items-center",
            ),
        )}
        data-testid={testidTable ? `${testidTable}-spinner` : undefined}
      >
        <td colSpan={columns?.length ?? 1}>
          <div className="flex justify-center items-center">
            <Spinner />
          </div>
        </td>
      </tr>
    );
  }
  return <></>;
};

export default PillarTableSpinner;
